import {licenseCegString} from '../../config/casinoLicense';

export default {
    mounted() {
        if (!licenseCegString) {
            return;
        }

        window.addEventListener('load', () => {
            this.initCeg();
        });

        this.initCeg();
    },

    methods: {
        initCeg() {
            if (!document.getElementById('ceg-script-' . licenseCegString)) {
                let cegScript = document.createElement('script');
                cegScript.setAttribute('src', `https://${licenseCegString}.curacao-egaming.com/ceg-seal.js`);
                cegScript.setAttribute('id', 'ceg-script-' . licenseCegString);
                document.head.appendChild(cegScript);
            }

            let cegContainer = document.getElementsByClassName('ceg-license')[0];

            if (!cegContainer) {
                return;
            }

            cegContainer.setAttribute('id', 'ceg-' + licenseCegString);
            cegContainer.setAttribute('data-ceg-seal-id', licenseCegString);

            let cegStr = "ceg_" + licenseCegString.split("-").join("_");
            let ceg = window[cegStr];

            if (ceg) {
                ceg.init();
            }
        },
    },
}